import _keyBy from 'lodash/keyBy';
import _get from 'lodash/get';
import API from "../../constants/api";


export const Invoke = ( url, method = 'GET', data ) => {

  let option = {
    method,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
  }

  if (method !== 'GET' && data) {
    option.body = JSON.stringify(data);
  }

  return fetch( url, option )
    .then((res) => {
      return res.json();
    }).catch((error) => {
      return error;
    })
};

export const dashboard = () => Invoke(API.poolStats)
  .then(async res => {

    // const oldResp = await Invoke('/api/pool');
    // debugger;
    const gotError = res.status !== 200
    if (gotError) {
      return
    }
    let diff = 0x0025F3/1e3;
    let result = _keyBy(res.stats, 'currency')['ETH'];

    // const xmrDiff = 1e2;

    return {
      eth: {
          calculatedUSD: (result.income * result.usd).toFixed(2),
          calculatedCoin: (result.income).toFixed(5),
          calculatedUSD1d: (result.meanIncome24h * result.usd).toFixed(2),
          calculatedCoin1d: (result.meanIncome24h).toFixed(5),
          hashrate:
            (res.eth.hashrate/diff + parseInt(result.hashrate)).toFixed(2),
          blocksCount:
            parseInt(res.ethFound.blocks/diff, 10) + result.blocks
      },
    };

  });

export const getStatsPool = (cur) => Invoke(API.statsPool(cur))
  .then(async res => {
    const clearCur = cur.toLowerCase();
    const gotError = !res || res.error;

    if (gotError) {
      return;
    }

    return {...res};
    // return {
    //   [clearCur]: {...res},
    // };

  });
